import React from 'react';
import { Box, Typography, FormControlLabel, Checkbox, TextField } from '@mui/material';

const GenericCheckboxGroup = ({ title, options, onOptionChange }) => {
  // Formatea la clave (ejemplo: "manoMunieca" → "Mano Munieca")
  const formatLabel = (key) =>
    key.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase());

  return (
    <Box sx={{ marginBottom: 2, border: "1px solid #ccc", padding: 2, borderRadius: 1 }}>
      <Typography variant='subtitle1' sx={{ mb: 2, fontWeight: 'bold' }}>
        {title}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column'}}>
        {Object.keys(options).map((key) => {
          if (key === 'otros') {
            return (
              <TextField
                key={key}
                size='small'
                label={formatLabel(key) + " (especificar)"}
                variant="outlined"
                sx={{ width: "25%", marginBottom: 4 }}
                value={options[key]}
                onChange={(e) => onOptionChange(key, e.target.value)}
              />
            );
          }
          return (
            <FormControlLabel
              key={key}
              control={
                <Checkbox
                  checked={options[key]}
                  onChange={(e) => onOptionChange(key, e.target.checked)}
                />
              }
              label={formatLabel(key)}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default GenericCheckboxGroup;
